import { createFileRoute } from "@tanstack/react-router";
import { BrewSensoryTemplatesPage } from "@/features/brew-sensory/brew-sensory-templates-page";

export const Route = createFileRoute("/food-app/sensory/templates")({
  component: BrewSensoryTemplatesPage,
});
